import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'KtKBuF',
    defaultMessage: 'End of notification',
    description: 'Title shown at the bottom of the notification hub list',
  },
  description: {
    id: 'FDyVI3',
    defaultMessage: 'You are viewing the last 30 days of notification and older notifications are automatically cleared',
    description: 'Description explaining the notification retention policy',
  },
});
